<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-dark-red" sprite="call-block" />
          Call Blocking
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-dark-red" sprite="call-block" />
            Call Blocking
          </h1>
        </el-col>

        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total }}
          </el-tag>
        </el-col>
      </el-row>

      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable />
          <el-button
            class="ml-10 hidden-xs-only"
            @click="doExport"
          >
            Export
          </el-button>
        </div>
        <div class="box right">
          <el-button @click="createVisible = true">Add New</el-button>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{enabled: true, gt: 50, oSize: 0}"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <!-- ⭐ Create Dialog ⭐ -->
    <el-dialog
      id="create-modal"
      class="form-modal"
      :visible.sync="createVisible"
      v-loading="createProcessing"
      :fullscreen="true"
      :show-close="false"
      :modal="false"
    >
      <div id="create-modal-header" class="modal-header">
        <div class="modal-header-layout flex grid-6 align-center">
          <h1 class="modal-title col-2">Create Blacklist Number</h1>
          <div class="modal-actions col-2">
            <el-button type="primary" @click="createOperation">Create</el-button>
            <el-button type="default" class="hidden-xs-only" @click="cancelOperation('create')">Cancel</el-button>
            <el-button type="default" icon="el-icon-close" class="hidden-sm-and-up" @click="cancelOperation('create')"></el-button>
          </div>
        </div>
      </div>

      <el-form>
        <!-- CallerID -->
        <div class="el-input el-input--prefix">
          <input
            v-model="createForm.callerId"
            type="text"
            autocomplete="off"
            placeholder="Enter number"
            class="el-input__inner"
            v-mask="'(###)-###-####'"
          />
          <span class="el-input__prefix">Number</span>
        </div>
        <el-input
          placeholder="Enter reason for blocking"
          v-model="createForm.reason"
        >
          <template slot="prefix">Reason for blocking</template>
        </el-input>
      </el-form>
    </el-dialog>

    <!-- ⭐ Edit Dialog ⭐ -->
    <el-dialog
      id="edit-modal"
      class="form-modal"
      :visible.sync="editVisible"
      v-loading="editProcessing"
      :fullscreen="true"
      :show-close="false"
      :modal="false"
    >
      <div id="edit-modal-header" class="modal-header">
        <div class="modal-header-layout flex grid-6 align-center">
          <h1 class="modal-title col-2">View / Edit Blacklist Number</h1>
          <div class="modal-actions col-2">
            <el-button type="primary" @click="editOperation">Save</el-button>
            <el-button type="default" class="hidden-xs-only" @click="cancelOperation('edit')">Cancel</el-button>
            <el-button type="default" icon="el-icon-close" class="hidden-sm-and-up" @click="cancelOperation('edit')"></el-button>
          </div>
        </div>
      </div>

      <el-form>
        <recent-audits
				service="Call Blocking" :record="selectedCallBlocking" />
        <!-- CallerID -->
        <div class="el-input el-input--prefix">
          <input
            v-model="editForm.callerId"
            type="text"
            autocomplete="off"
            placeholder="Enter number"
            class="el-input__inner"
            v-mask="'(###)-###-####'"
          />
          <span class="el-input__prefix">Number</span>
        </div>
        <el-input
          placeholder="Enter reason for blocking"
          v-model="editForm.reason"
        >
          <template slot="prefix">Reason for blocking</template>
        </el-input>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import feathersClient from "../../../feathers/feathers-client";
import moment from "moment-timezone";
import {debounce} from 'lodash';
import {globalEventBus} from "@/globalEventBus";
import RecentAudits from '@/components/RecentAudits';
import {ExportToCsv} from "export-to-csv";
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "CallBlockingTable",
  components: { RecentAudits },
  data() {
    return {
      eventChannel: null,
      tableData: [],
      allCallBlocking: [],
      search: "",
      visibleActionsId: "",
      createVisible: false,
      createProcessing: false,
      total: 0,
      tableLoading: false,
      createForm: {
        callerId: "",
        reason: "",
      },
      selectedCallBlocking: null,
      editVisible: false,
      editProcessing: false,
      editForm: {
        callerId: "",
        reason: "",
      },
      tableColumns: [
        {
          field: 'sprite',
          title: '',
          width: 50,
          slots: {
            default: ({row}) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-red" sprite="call-block"/>
                </div>
              ]
            }
          }
        },
        {
          field: 'number',
          title: 'Number',
          minWidth: 150,
          sortable: true,
          slots: {
            default: ({row}) => {
              return [
                <span>{this.numberFormatter(row.callerId)}</span>
              ]
            }
          }
        },
        {
          field: 'reason',
          title: 'Description',
          minWidth: 200,
          sortable: true
        },
        {
          field: 'actions',
          title: '',
          minWidth: '150',
          showOverflow: false,
          slots: {
            default: ({row}) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={'edit-'+ row.id}
                    icon="el-icon-edit"
                    onClick={() => this.openEditModal(row.id)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    id={'delete-'+row.id}
                    icon="el-icon-delete"
                    onClick={() => this.deleteOperation(row.id)}
                    class="table-action-button icon-red"
                  />
                </div>
              ]
            }
          }
        }
      ]
    };
  },
  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    },
    userOffsetMinutes(){
      return this.$store.state.userTimeOffset;
    }
  },
  watch: {
    selectedTenant() {
      this.findBlacklist();
      feathersClient.service('channel-memberships').remove(null,  {query: {channelName: this.eventChannel}});
      this.joinSocketChannel();
    },
    user() {
      this.findBlacklist();
      if(!this.eventChannel){
        this.joinSocketChannel();
      }
    },

    selectedCallBlocking(val) {
      if (val) {
        const { callerId, reason } = val;
        this.editForm.callerId = callerId;
        this.editForm.reason = reason;
      }
    },

    search: debounce(function () {
      this.searchRecords();
    }, 500)
  },
  methods: {
    ...mapActions("call-blocking", {
      createBlacklist: "create",
      patchBlacklist: "patch",
      deleteBlacklist: "remove",
    }),

    doExport(){
      const data = [...this.tableData];
      if(data.length){

        const writeData = data.map(item => ({
          number: item.callerId,
          reason: item.reason
        }));

        const options = {
          filename: 'call_blocking',
          showLabels: true,
          headers: ['Name', 'Description']
        }

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    },

    searchRecords() {
      if(this.search.length){
        this.tableData = this.allCallBlocking.filter(
          (data) =>
            !this.search ||
            data.callerId
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            data.reason.toLowerCase().includes(this.search.toLowerCase()) ||
            data.inserted.toLowerCase().includes(this.search.toLowerCase())
        );
      } else{
        this.tableData = [...this.allCallBlocking];
      }
      this.total = this.tableData.length;
    },

    //General Form and Table Operations
    cellClicked(data){
      if(data.column.property !== 'actions'){
        this.openEditModal(data.row.id);
      }
    },

    rowHover(data){
      this.visibleActionsId = data.row.id;
    },

    rowLeave(){
      this.visibleActionsId = "";
    },

    openEditModal(id) {
      feathersClient
        .service("call-blocking")
        .get(id)
        .then((res) => (this.selectedCallBlocking = res));
      this.editVisible = true;
    },

    findBlacklist(){
      this.tableLoading = false;
      this.tableData = [];
      feathersClient.service('call-blocking').find({
        query: {
          tenantId: this.selectedTenant.id
        }
      }).then( res => {
        this.tableData = [...res];
        this.allCallBlocking = [...res];
        this.total = res.length;
        this.tableLoading = false;
      }).catch( () => {
        this.tableLoading = false;
      });
    },

    createOperation() {
      this.$confirm("Create blacklist number?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.createProcessing = true;
          const createBody = {
            tenantId: this.selectedTenant.id,
            ...this.createForm,
          };
          createBody.callerId = createBody.callerId.replace("(", "");
          createBody.callerId = createBody.callerId.replace(")", "");
          createBody.callerId = createBody.callerId.replace(/-/g, "");

          this.createBlacklist(createBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Created successfully!",
                type: "success",
              });
              this.createProcessing = false;
              this.cancelOperation("create");
            })
            .catch((error) => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error",
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error",
                });
              }
              this.createProcessing = false;
            });
        })
        .catch(() => true);
    },

    editOperation() {
      this.$confirm("Edit blacklist number", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.editProcessing = true;

          const editBody = {
            tenantId: this.selectedTenant.id,
            ...this.editForm,
          };

          editBody.callerId = editBody.callerId.replace("(", "");
          editBody.callerId = editBody.callerId.replace(")", "");
          editBody.callerId = editBody.callerId.replace(/-/g, "");

          this.patchBlacklist([this.selectedCallBlocking.id, editBody])
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Edited successfully!",
                type: "success",
              });
              this.editProcessing = false;
              this.cancelOperation("edit");
            })
            .catch((error) => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error",
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error",
                });
              }
              this.editProcessing = false;
            });
        })
        .catch(() => true);
    },

    deleteOperation(id) {
      this.$confirm("Delete blacklist number?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.tableLoading = true;
          this.deleteBlacklist(id)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Deleted successfully!",
                type: "success",
              });
              this.tableLoading = false;
            })
            .catch((error) => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error",
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error",
                });
              }
              this.tableLoading = false;
            });
        })
        .catch(() => true);
    },

    cancelOperation(type) {
      if (type === "create") {
        this.createVisible = false;
        this.createForm = {
          callerId: "",
          reason: "",
        };
      } else if (type === "edit") {
        this.editVisible = false;
        this.editForm = {
          callerId: "",
          reason: "",
        };
      }
    },

    numberFormatter(number) {
      return phoneNumberFormatter(number);
    },

    timeFormatter(value) {
      const offsetMinutes = Math.abs(this.userOffsetMinutes);

      return this.userOffsetMinutes < 0
        ? moment(value)
          .subtract(offsetMinutes, "minutes")
          .format("M/DD/YY h:mm A")
        : moment(value)
          .add(offsetMinutes, "minutes")
          .format("M/DD/YY h:mm A");
    },

    joinSocketChannel(){
      const channelService = feathersClient.service('channel-memberships');
      const data = {
        roomType: 'admins',
        tenantId: this.selectedTenant.id
      };
      channelService.create(data).then(res => {this.eventChannel = `${data.roomType}/${data.tenantId}`});
    },

    removeListeners(){
      feathersClient.service('call-blocking').removeListener('patched');
      feathersClient.service('call-blocking').removeListener('created');
      feathersClient.service('call-blocking').removeListener('removed');
      globalEventBus.$off('appReconnected');
    }
  },
  created(){
    //event listeners
    //monitor socket connection and reconnect to channel
    globalEventBus.$on('appReconnected', () => {
      this.joinSocketChannel();
    });

    //record was updated
    feathersClient.service('call-blocking').on('patched', (data) => {
      const updateIndex = this.tableData.findIndex(item => item.id === data.id);
      const updateAllIndex = this.allCallBlocking.findIndex(item => item.id === data.id);
      if(updateIndex >= 0){this.tableData.splice(updateIndex, 1, data);}
      if(updateAllIndex >= 0){ this.allCallBlocking.splice(updateAllIndex, 1, data);}
    });

    //record was created
    feathersClient.service('call-blocking').on('created', (data) => {
      this.tableData.push(data);
      this.allCallBlocking.push(data);
    });

    //record was deleted
    feathersClient.service('call-blocking').on('removed', (data) => {
      const indexToRemove = this.tableData.findIndex(item => item.id === data.id);
      const indexAllToRemove = this.allCallBlocking.findIndex(item => item.id === data.id);
      if(indexToRemove >= 0){this.tableData.splice(indexToRemove, 1);}
      if(indexAllToRemove >= 0){this.allCallBlocking.splice(indexAllToRemove, 1);}
    });
  },
  mounted() {
    if (this.user) {
      this.findBlacklist();
      this.joinSocketChannel();
    }
  },

  beforeDestroy() {
    this.removeListeners();
    feathersClient.service('channel-memberships').remove(null, {query:{channelName: this.eventChannel}});
  },

  filters: {
    formatNumber(value) {
      return `(${value.substr(0, 3)}) ${value.substr(3, 3)}-${value.substr(
        6,
        4
      )}`;
    },
  },
};
</script>

